import { Component, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { initializeApp, getApps, getApp } from 'firebase/app';
import { isSupported, getMessaging, onMessage } from 'firebase/messaging';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(private toastCtrl: ToastController) {}

  async ngOnInit(): Promise<void> {
    if (!(await isSupported())) return;

    const firebaseApp = getApps().length === 0
      ? initializeApp(environment.firebase)
      : getApp();
    const messaging = getMessaging(firebaseApp);

    onMessage(messaging, payload => {
      this.toastCtrl.create({
        message: payload.notification?.body ?? 'New notification',
        duration: 4000,
        position: 'top',
        color: 'primary',
      }).then(t => t.present());
    });
  }
}
